export const setFeedback = (payload) => {
  return {
    type: 'SET_FEEDBACK',
    feedback: payload,
  };
};

export const setFeedbackLoading = (payload) => {
  return {
    type: 'SET_FEEDBACK_LOADING',
    feedbackLoading: payload,
  };
};

export const setPendingFeedback = (payload) => {
  return {
    type: 'SET_PENDING_FEEDBACK',
    pendingFeedback: payload,
  };
};
